import React, { useEffect, useState } from 'react';
import { Dropdown, Modal } from 'react-bootstrap';
import * as DateFns from 'date-fns';

import { FIELD_TYPE, FILTER_GLOBAL_KEYS, LEAGUE, NCAA_FBS_GAME, NFL_GAME, PRACTICE } from '../../config/constants';
import { SERVER } from '../../config/server.config';
import DatePicker from '../Shared/DatePicker/DatePicker';
import TimeSelector from '../Shared/TimeSelector';
import PeriodsList from '../Shared/Periods/PeriodsList';
import {
  buildIntensityFilter,
  getTeamData,
  getTeamsDropdownLabel,
  getVenues,
  isCC,
  isNCAA,
  isNCAAAllSports,
  isTA,
  text_truncate
} from '../../helpers';
import { selectIntensitiesByTeam, useFiltersState, useProfilesState, useUserState } from '../../store/hooks';
import { useEventsDispatch } from '../../store/hooks/events';
import { CreatePracticeModalPropsType } from './types';
import { Drill, TeamData } from '../../config/commonTypes';
import { VenueType } from '../../store/types';
import { SimpleMultiSelectorPresentational } from 'components/Shared/Filters/SimpleMultiSelector';
import { useHistory } from 'react-router-dom';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'components/Shared/Loader';

const CreatePracticeModal = ({ show, handleClose, day }: CreatePracticeModalPropsType) => {

  const user = useUserState();
  const { profiles: profilesData } = useProfilesState();


  const { loadEvents } = useEventsDispatch();
  const { [FILTER_GLOBAL_KEYS.VENUES]: venues } = useFiltersState('_', FILTER_GLOBAL_KEYS.VENUES);
  const [profile, setProfile] = useState<string | number>(-1);
  const [venue, setVenue] = useState<VenueType>({
    siteId: -1,
    siteName: '',
    type: 'practice',
    teamId: '',
    league: '',
    label: '',
    teamAbbr: ''
  } as VenueType);
  const [intensity, setIntensity] = useState<string | number>(-1);
  const [intensityArray, setIntensityArray] = useState<string[]>([]);
  const [showFilter, setShowFilter] = useState(0);
  const [field, setField] = useState<string | number>(0);
  const [name, setName] = useState('');
  const [date, setDate] = useState(day);
  const [periods, setPeriods] = useState<Drill[]>([]);
  const [league, setLeague] = useState({ label: 'NFL practice', value: user.league });
  const [teamId, setTeamId] = useState<string | number>(-1);
  const [description, setDescription] = useState('');
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const history = useHistory();
  const{ createAndGoFlag } = useFlagsState();
  const {  createAndGoPracticeFlag } = useFlagsDispatch();
  const dispatch = useDispatch();

  const intensities = useSelector(
  selectIntensitiesByTeam(teamId.toString())
);
  const intensityFilter = buildIntensityFilter(intensities?? []);

  if (day) {
    day.setHours(7);
  }
  const close = () => setShowFilter(-1);
  useEffect(() => {
  setIntensity(-1);
  setIntensityArray([]);
}, [teamId]);

  const handleIntensity = (value:string[]) =>{
    if(value.length === 0 ){
      setIntensity(-1);
    }else{
    let intensities='';
    value.forEach((value, index)=>{
      intensities= index === 0? value : intensities+','+value;
    });
    setIntensity(intensities);
  }
  };
  const handleOpen = () => {
    setProfile(-1);
    setIntensity(-1);
    setField(0);
    setName('');
    setDate(day);
    setPeriods([]);
    if (isNCAA(user) || isTA(user)) {
      setLeague({ label: 'NFL Practice', value: user.league });
    } else {
      setLeague({ label: 'NFL Practice', value: 'nfl' });
    }
    setTeamId((isTA(user) || isNCAA(user)) ? user.teamId : -1);
    //setVenue()
    setDescription('');
  };
  const handleChangeName = (event: React.ChangeEvent<HTMLInputElement>) => {
  if(event.target.value!== ' ')setName(event.target.value);
  };
  const handleChangeDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDescription(event.target.value);
  };
  const isValidPractice = () => {
    return intensity !== -1 && field !== -1 && name !== '' && name !== ' ' && teamId !== -1;
  };
  const createPractice = (isCreateAndGo:boolean) => {
    if(isCreateAndGo){
      createAndGoPracticeFlag(true);
    }
    const siteid = [];
    const sitename = [];
    const type = [];
    const currentDate = new Date();

    if (isNCAA(user) || isTA(user)) {
      getVenues(venues, league.value, 'practice').forEach((venues: VenueType) => {
        siteid.push(venues.siteId);
        sitename.push(venues.siteName);
        type.push(venues.type);
      });
    } else {
      siteid.push(venue.siteId);
      sitename.push(venue.siteName);
      type.push(venue.type);
    }

    if (DateFns.isAfter(date, currentDate) || DateFns.isSameDay(date, currentDate)) {
      const payload = {
        description: description,
        drills: periods,
        // end: dateFns.setHours(date, date.getHours()).getTime() + 3600000,
        extraData: {},
        intensity: intensity,
        league: league.value,
        name: name,
        profileName: profilesData && profilesData[teamId] ? profilesData[teamId].length > 0 && teamId !== -1 && profile !== -1 ? profilesData[teamId][profile].profileName : '' : '',
        rooftype: FIELD_TYPE.types[field], // should it be 'roofType'?
        siteId: siteid[0],
        siteName: sitename[0],
        start: DateFns.setHours(date, date.getHours()).getTime(),
        teamId,
        type: type[0]
      };
  let responseBody: any;
  let practiceId: string;
   fetch(SERVER.CREATE_PRACTICE(teamId, league.value, isMobile),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }).then(async function(res){
          responseBody = await res.json();
      })
      .then(async response => {
       if(isCreateAndGo){
          practiceId = responseBody.results[0]._id;
          const finished = () => {
          history.push(`/view/practice/${practiceId}/manage`);
        };
        dispatch(loadEvents(true, false, true, true, isMobile, finished )); 
       }else{
        dispatch(loadEvents(true, false, true, true, isMobile)); 
       }
       
    })
        .catch(error => console.error(error));
        if(!isCreateAndGo) handleClose();
    } else {
      alert('Please enter a future day.');
      createAndGoPracticeFlag(false);
    }

    
  };
  const onApplyTimeSelector = (hour: number, minute: number, second: number, am: boolean) => {
    if (am === true) {
      if (hour === 12) {
        hour = 0;
      }
    } else {
      if (hour !== 12) {
        hour += 12;
      }
    }
    let newTime = date;
    newTime = DateFns.setHours(newTime, hour);
    newTime = DateFns.setMinutes(newTime, minute);
    newTime = DateFns.setSeconds(newTime, second);
    setDate(newTime);
  };

  const handleLeagueChange = (league: { label: string, value: string }) => {
    setLeague(league);
    setTeamId(-1);
    setProfile(-1);
  };

  const leagueItems: JSX.Element[] = [];
  if (isCC(user)) {
    LEAGUE.types.forEach((type: { value: { label: string, value: string } }, index) => {
      if (type.value.label !== NCAA_FBS_GAME && type.value.label !== NFL_GAME) {
        leagueItems.push(
          <Dropdown.Item
            key={'league' + index}
            onClick={() => handleLeagueChange(type.value)}
          >
            {type.value.label}
          </Dropdown.Item>);
      }
    });
  }

  const handleTeamChange = (venue: VenueType) => {
    const teamData = getTeamData(venue.teamId, venue.league);
    setVenue({
      ...venue,
      ...teamData
    });
    setTeamId(venue.teamId);
    setProfile(-1);
  };

  let teamItems = [];
  if (!isNCAAAllSports(user)) {
    teamItems = getVenues(venues, league.value, 'practice').map((venue: VenueType, index: number) => {
      return (
        <Dropdown.Item
          key={'team' + index}
          onClick={() => handleTeamChange(venue)}
        >
          {`(${venue.teamId}) ${venue.siteName}`}
        </Dropdown.Item>);
    });
  } else {
    teamItems = [...getVenues(venues, 'ncaa-fbs', PRACTICE), ...getVenues(venues, 'ncaa-mlax', PRACTICE)]
      .map((venue, index) => {
        type A = TeamData & VenueType;
        const venueData: A = { ...venue, ...getTeamData(venue.teamId) } as A;
        return (
          <Dropdown.Item
            key={'team' + index}
            onClick={() => {
              handleTeamChange(venueData);
              setLeague({ label: 'NCAA', value: venueData.league });
            }}
          >
            {venueData.league === 'ncaa-fbs' || venueData.league === 'ncaa-mlax' ?
              `${venueData.teamAbbr.toUpperCase()} ${venueData.teamNick}` : `(${venueData.teamId}) ${venueData.siteName}`}
          </Dropdown.Item>);
      });
  }
  /* const teamOtherItem = getVenues(league.value, 'practice').map((venues) => {
   return handleTeamChange(venues);
   }) */


  return (
    <Modal show={show} onHide={!createAndGoFlag? handleClose : undefined } className="modal-content-08" keyboard={false} onShow={handleOpen}>
      <Loader forceLoader={createAndGoFlag? true : false}>
      <Modal.Header closeButton>
        Create a Practice
      </Modal.Header>
      <Modal.Body>
        <div className="createp">
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required={true} value={name} onChange={handleChangeName}
              style={name === '' ? undefined : { backgroundImage: 'none' }}
            />
            <span className="material-label">Enter Practice Name</span>
          </div>
          <div className="material-textbox" id="first-name-input">
            <input
              className="material-input" required={true} value={description}
              onChange={handleChangeDescription}
              style={{ backgroundImage: 'none' }}
            />
            <span className="material-label">Enter Practice Description</span>
          </div>
          <div className="create-00">
            {!((isTA(user) || isNCAA(user)) || isNCAAAllSports(user)) && (
              <div className="d-profile-t">
                <><p>League</p>
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className="btn-gray-l">
                      {/*Conditionally renders Select or provided intensity string*/}
                      {!league.label ? 'Select' :
                        league.label === '' ? 'Select' : text_truncate(league.label, 13)}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ width: '142px', height: 'fit-content' }}>
                      {leagueItems}
                    </Dropdown.Menu>
                  </Dropdown></>
              </div>
            )}
            {!((isTA(user) || isNCAA(user))) && (
              <div className="d-profile-t">
                <p>Team{ teamId === -1 ? <span style={{color: 'red'}}>*</span>: null}</p>
                <Dropdown>
                  <Dropdown.Toggle
                    id="dropdown-basic" style={!isCC(user) ? { width: '190px' } : {}} className="btn-gray-l"
                  >
                    <label className="short-text">
                    {/*Conditionally renders Select or provided intensity string*/}
                    {/*role === 'TeamAdmin' ? teamAdminItem : 'Select'*/}
                    {getTeamsDropdownLabel(teamId, venue)}
                    </label>
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ width: '190px' }}>
                    {teamItems}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
            <div>
              <p>Profile</p>
              <Dropdown
                onSelect={(event) => {
                  setProfile(event as string);
                }}
              >
                <Dropdown.Toggle id="dropdown-basic" className={'padding-profile-items btn-gray-l'}>
                  <label
                    className="short-text">{profile === -1 ? 'Select' : profilesData[teamId][profile] ? profilesData[teamId][profile].profileName : 'Select'}</label>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {profilesData && teamId !== -1 && profilesData[teamId] ?
                    profilesData[teamId].map((profile, index) => (
                      <Dropdown.Item
                        eventKey={'' + index}
                        key={profile.profileName} className={'padding-profile-items'} onClick={() => {
                        setPeriods(profile.drills ? [...profile.drills] : []);
                        setProfile(index);
                      }}
                      >
                        {profile.profileName}</Dropdown.Item>)) :
                    null}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className="create-01">
            <div>
              <p>Date & Time</p>
              <div className="timep">
                <DatePicker date={date} setDate={setDate} />
                <TimeSelector time={date} applyChanges={onApplyTimeSelector} /*className="btn-gray-l" // not uset*/ />
              </div>
            </div>
            <div>
              <p>Field Type</p>
              <Dropdown
                onSelect={(event) => {
                  setField(event as string);
                }}
              >
                <Dropdown.Toggle id="dropdown-basic" className="btn-gray-l">
                  {field === -1 ? 'Select' : FIELD_TYPE.types[field]}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {FIELD_TYPE.types.map((field, index) => (
                    <Dropdown.Item eventKey={'' + index} key={field}>{field}</Dropdown.Item>))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div style={teamId === -1? {opacity: '0.5', pointerEvents: 'none'}:{}}>
              <p>Intensity{ intensity === -1 || intensity === '' ? <span style={{color: 'red'}}>*</span>: null}</p>
              <SimpleMultiSelectorPresentational
            show={showFilter === 3}
            close={close}
            open={() => setShowFilter(3)}
            filterData={intensityArray.map((type) => ({ value: type, name: type }))}
            changeFilterData={(values) => {handleIntensity(values.map(val => val.value));
              setIntensityArray(values.map(val => val.value));
            }}
            type={intensityFilter}
            forceScope={'INTENSITY_DROPDOWN'}
          />
            </div>
          </div>
          <hr />
          <PeriodsList
            league={league.value}
            periods={periods}
            setPeriods={setPeriods}
            teamId={teamId.toString()}
          />
        </div>
        <div className="tt-ww">
          <button className="btn-transparet" onClick={handleClose}>Cancel</button>
          <button
            className="btn-blue" style={isValidPractice() || createAndGoFlag ? undefined : { opacity: '0.5', pointerEvents: 'none' }}
            onClick={() => {
              createPractice(false);
            }}
          >
            Create
          </button>
          <button
            className="btn-blue" style={isValidPractice() || createAndGoFlag ? {marginLeft: '5px', width: '74px'} : { marginLeft: '5px', width: '74px', opacity: '0.5', pointerEvents: 'none' }}
            onClick={() => {
              createPractice(true);
            }}
          >
            Create & Go
          </button>
        </div>
      </Modal.Body>
      </Loader>
    </Modal>
  );
};

export default CreatePracticeModal;
